<template>
  <a-form-model-item :label="field.label" :label-col="fieldLabelCol" :wrapper-col="fieldWrapperCol">
    <!-- 计划名称 -->
    <a-input v-if="field.key === 'name'" :value="form.name" allow-clear placeholder="计划名称" @change="handleInputChange('name', $event)" />
    <!-- 状态 -->
    <a-select v-else-if="field.key === 'status'" :value="form.status" mode="multiple" allow-clear placeholder="状态" @change="handleSelectChange('status', $event)">
      <a-select-option v-for="(item, index) in options.statusList" :key="index" :value="item.value">
        <a-badge :status="item.status" :color="item.color" :text="item.label" />
      </a-select-option>
    </a-select>
    <!-- 类型 -->
    <a-select v-else-if="field.key === 'type'" :value="form.type" mode="multiple" allow-clear placeholder="类型" @change="handleSelectChange('type', $event)">
      <a-select-option v-for="(item, index) in options.types" :key="index" :value="item.value">
        {{ item.label }}
      </a-select-option>
    </a-select>
    <!-- 测试负责人 -->
    <user-select v-else-if="field.key === 'handlers'" :value="form.handlers" mode="multiple" allow-clear show-search show-all placeholder="测试负责人" :project-id="projectId" @change="handleSelectChange('handlers', $event)" />
    <!-- 创建人 -->
    <user-select v-else-if="field.key === 'creator'" :value="form.creator" mode="multiple" allow-clear show-search show-all placeholder="创建人" :project-id="projectId" @change="handleSelectChange('creator', $event)" />
    <!-- 关联需求 -->
    <a-select v-else-if="field.key === 'requirement'" :value="form.requirement_id" placeholder="关联需求" allow-clear show-search :filter-option="false" :not-found-content="searchData.story.searching ? undefined : null" @search="handleSearch('story', $event)" @change="handleSelectChange('requirement_id', $event)">
      <a-spin v-if="searchData.story.searching" slot="notFoundContent" size="small" />
      <a-select-option v-for="item in searchData.story.data" :key="item.value" :value="item.value">
        {{ item.label }}
      </a-select-option>
    </a-select>
    <!-- 时间筛选 -->
    <a-input-group v-else-if="field.key === 'dateRange'" compact>
      <a-select :value="form.time_field" style="width: 30%" @change="handleSelectChange('time_field', $event)">
        <a-select-option value="start_time">开始时间</a-select-option>
        <a-select-option value="end_time">结束时间</a-select-option>
        <a-select-option value="created_time">创建时间</a-select-option>
      </a-select>
      <a-date-picker :value="form.start_time" style="width: 35%" placeholder="开始时间" value-format="YYYY-MM-DD" @change="handleDateChange('start_time', $event)" />
      <a-date-picker :value="form.end_time" style="width: 35%" placeholder="结束时间" value-format="YYYY-MM-DD" @change="handleDateChange('end_time', $event)" />
    </a-input-group>
  </a-form-model-item>
</template>

<script>
import UserSelect from '@/components/User/UserSelect';

export default {
  name: 'TestPlanFilterFormItem',
  components: { UserSelect },
  props: {
    field: {
      type: Object,
      required: true
    },
    form: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      required: true,
      default: () => ({
        statusList: [],
        types: []
      })
    },
    searchData: {
      type: Object,
      required: true,
      default: () => ({
        story: {
          searching: false,
          data: []
        }
      })
    },
    projectId: {
      type: Number,
      default: 0
    },
    labelCol: {
      type: Object,
      default: null
    },
    wrapperCol: {
      type: Object,
      default: null
    }
  },
  computed: {
    fieldLabelCol() {
      return this.labelCol === null ? { span: this.field.labelSpan || 6 } : this.labelCol;
    },
    fieldWrapperCol() {
      return this.wrapperCol === null ? { span: this.field.wrapperSpan || 18 } : this.wrapperCol;
    }
  },
  methods: {
    handleInputChange(key, event) {
      this.$emit('change', { key, value: event.target.value });
    },

    handleSelectChange(key, value) {
      this.$emit('change', { key, value });
    },

    handleDateChange(key, value) {
      this.$emit('change', { key, value });
    },

    handleSearch(key, value) {
      this.$emit('search', { key, value });
    }
  }
};
</script>

<style lang="less" scoped>
:deep(.ant-form-item) {
  margin-bottom: 0px;

  .ant-form-item-label {
    text-align: right;
    color: #495057;
    padding-right: 8px;
  }
}

:deep(.ant-input),
:deep(.ant-select),
:deep(.ant-picker),
:deep(.ant-tree-select),
:deep(.ant-calendar-picker) {
  width: 100%;
}
</style>
